export const API_EXTERNAL_ENDPOINT = 'outings/:outingId/cottages'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/outings/cottages-add'
